import Vue from "vue";

export const featuresService = {
  list
};

function list() {
  return Vue.axios.get("v1/features");
}
